enum StatusFassung {
	Entwurf = "ENTWURF",
	Endfassung = "ENDFASSUNG",
}

export default StatusFassung;
